import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Favorite() {
    const [favorites, setFavorites] = useState(() => {
        const saved = localStorage.getItem('favorite_items');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        const handleStorageChange = () => {
            const saved = localStorage.getItem('favorite_items');
            setFavorites(saved ? JSON.parse(saved) : []);
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    // Function to remove item from favorites
    const toggleLike = (item) => {
        const updated = favorites.filter(fav => fav.menuItemName !== item.menuItemName);
        setFavorites(updated);
        localStorage.setItem('favorite_items', JSON.stringify(updated));
        window.dispatchEvent(new Event('storage'));
    };

    return (
        <>
            <PageSubTitle pagename="Favorite Items" />
            <section className='section'>
                <Container>
                    <Row className='justify-content-center'>
                        {favorites.length === 0 ? (
                            <Col md={12} className="text-center py-5">
                                <motion.div initial={{opacity: 0, y: 20}} animate={{opacity: 1, y: 0}} transition={{duration: 0.5}}>
                                    <div className="mb-4">
                                        <i className="ri-heart-line text-muted" style={{ fontSize: '70px' }}></i>
                                    </div>
                                    <h3 className="fw-semibold text-muted">No Favorite Items Yet</h3>
                                    <p className="text-muted mx-auto fs-18 mb-4" style={{ maxWidth: '400px' }}>
                                        Go to our menu to explore delicious dishes and add them to your favorites list!
                                    </p>
                                    <Link to="/food_menu" className="btn btn-danger px-4 py-2 fs-18 rounded-pill">
                                        Explore Menu
                                    </Link>
                                </motion.div>
                            </Col>
                        ) : (
                            favorites.map((data, i) => (
                                <Col sm={6} lg={4} xxl={3} key={i} className='mb-4'>
                                    <Card className='card-hover menu-item-card h-100 mb-0'>
                                        <Card.Body className='pb-0'>
                                            <div className='menu-item-img-box px-3 py-2 rounded-3'>
                                                <Image src={require(`../images/menu-item/${data.menuFoodImg}`)} alt="" className='img-fluid png-img-shadow-sm' />
                                            </div>
                                            <div className='d-flex justify-content-between mt-3'>
                                                <h5 className='mb-0 fw-semibold'>{data.menuItemName}</h5>
                                                <div className="ms-3 cursor" onClick={() => toggleLike(data)}>
                                                    <i className="ri-heart-fill fs-20 text-danger"></i>
                                                </div>
                                            </div>
                                            <p className='text-muted'>{data.menuItemDesc}</p>
                                        </Card.Body>
                                        <Card.Footer className='bg-transparent border-0 pt-0 pb-3'>
                                            <div className='d-flex gap-1 text-warning'>
                                                <i className="ri-star-fill"></i>
                                                <i className="ri-star-fill"></i>
                                                <i className="ri-star-fill"></i>
                                                <i className="ri-star-fill"></i>
                                                <i className="ri-star-fill"></i>
                                            </div>
                                            <hr className='border-soft-dark' />
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <h5 className='text-danger fw-semibold mb-0'>{data.menuItemPrice}</h5>
                                                <Button variant='soft-danger' className='btn btn-xs'>Add to Card</Button>
                                            </div>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            ))
                        )}
                    </Row>
                </Container>
            </section>
        </>
    )
}
